// Chiamato da InsertForm, definisco tutti i campi del FORM e relativi Handle

import  { useState } from "react";
import OnePutDB from "../../actions/OnePutDB";

//Importo i valori iniziali per i campi del Form memorizzati in ValueArray
import {
  initialFValues,
  //menuTipologia,
  initialPartner,
  initialTeamMember,
  initialMedia,
  initialResponsabile,
} from "../../data/ValueArray";


export default function Useform() {
  //**************************************************************************************************
  // memorizzo l'array con tutti i campi del FORM
  //**************************************************************************************************
  const [values, setValues] = useState(initialFValues);

  //**************************************************************************************************
  // memorizzo (TextField) la parola chiave passata dopo il click del Chip
  //**************************************************************************************************
  const [tagg, setTagg] = useState("");

  //**************************************************************************************************
  // memorizzo (TextField) la parola chiave passata dopo il click del Chip (ricordati di inizializzare
  // BENE lo 'state')
  //**************************************************************************************************
  const [partner, setPartner] = useState(initialPartner);
  const [member, setMember] = useState(initialTeamMember);
  const [media, setMedia] = useState(initialMedia);
  const [responsabile, setResponsabile] = useState(initialResponsabile);

  const [isActive, setIsActive] = useState("true");

  //**************************************************************************************************
  // gestisco i valori che vengono digitati dai singoli elementi del FORM e il loro nome cercando di
  // rispettare i livelli dell'array (tipologia, parole chiave.....)
  //**************************************************************************************************
  const handleInputChange = (level, index) => (e) => {
    const { name, value } = e.target;
    if (!level) {
      setValues({
        ...values,
        [name]: value,
      });
    } else if (level === "Tipologia") {
      setValues({
        ...values,
        [level]: {
          ...values[level],
          [name]: value,
          abbreviazione: e.currentTarget.id,
        },
      });
    } else if (level === "Abstract") {
      setValues({
        ...values,
        [level]: {
          ...values[level],
          [name]: value,
        },
      });
    }
  };

  //**************************************************************************************************
  // controllo la pressione dei tasti di aggiunta Parole_Chiave, Partners, UNIFI_Team...
  //**************************************************************************************************
  const handleArray = (what) => {
    switch (what) {
      case "Tags":
        console.log("cerchi di aggiungere una PC");
        if (tagg !== "") {
          setValues({
            ...values,
            ["Parole_Chiave"]: [...values["Parole_Chiave"], tagg],
          });
          setTagg(""); // se vuoto non aggiungo nulla...
        }
        break;
      case "Partners":
        console.log("vuoi aggiungere un partner");
        //if (partner.name !== '') {
        if (partner.nome !== "") {
          console.log("sono dentro l'aggiunta di partner");
          setValues({
            ...values,
            ["Partner"]: [...values["Partner"], partner],
          });
          setPartner(initialPartner); // alla fine lo svuoto
        }
        break;
      case "Members":
        console.log("vuoi aggiungere un membro");
        //if (partner.name !== '') {
        if (member.nome !== "") {
          console.log("sono dentro l'aggiunta di membro");
          setValues({
            ...values,
            ["UNIFI_Team"]: [...values["UNIFI_Team"], member],
          });
          setMember(initialTeamMember); // alla fine lo svuoto
        }
        break;
      case "Media":
        console.log("vuoi aggiungere un Media");
        if (media.cosa !== "") {
          console.log("sono dentro l'aggiunta di un media");
          setValues({
            ...values,
            ["Media"]: [...values["Media"], media],
          });
          setMedia(initialMedia); // alla fine lo svuoto
        }
        break;
      case "Responsabile":
        console.log("vuoi aggiungere un Responsabile");
        //if (partner.name !== '') {
        if (responsabile.nome !== "") {
          console.log("sono dentro l'aggiunta di Responsabile");
          setValues({
            ...values,
            ["Responsabile"]: [...values["Responsabile"], responsabile],
          });
          setResponsabile(initialResponsabile); // alla fine lo svuoto
        }
        break;

      default:
    }
  };

  //**************************************************************************************************
  // Gestisco il riempimento dei campi testo di Parole_Chiave, Partners, UNIFI_Team...
  //**************************************************************************************************
  const handleChange = (what, ev) => {
    switch (what) {
      case "Tags":
        const { value } = ev.target;
        setTagg(value);
        break;
      case "Partners":
        //const {name, value} = ev.target;
        const name = ev.target.name;
        const val = ev.target.value;
        setPartner({ ...partner, [name]: val });
        break;
      case "Members":
        const membro = ev.target.name;
        const valore = ev.target.value;
        setMember({ ...member, [membro]: valore });
        break;
      case "Media":
        const art = ev.target.name;
        const valor = ev.target.value;
        setMedia({ ...media, [art]: valor });
        break;
      case "Responsabile":
        const respon = ev.target.name;
        const resp = ev.target.value;
        setResponsabile({ ...responsabile, [respon]: resp });
        break;

      default:
    }
  };

  //**************************************************************************************************
  // gestisco l'eliminazione delle singole Parole_Chiave, Partners, UNIFI_Team...
  // individuati dall'index
  //**************************************************************************************************
  const handleDel = (what, index) => {
    console.log("cancello #" + index);
    what.splice(index, 1);
    setValues({ ...values });

    // Devo impostare isActive  = 'true' per evitare errore nel backgroundImage se cancello 'immagine'
    if (what === values.Media) {
      setIsActive("true");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //console.log(values);

    //invio cosa devo salvare al componente che userà Axios ed invierà a funzione php sul server cosa mettere in MongoDB
    OnePutDB(values);

    window.alert("Aggiunto...");
    //resetto campi FORM
    handleResetForm();
  };

  //Svuoto i campi del FORM
  const handleResetForm = () => {
    setValues(initialFValues);
  };

  return {
    values,
    setValues,
    member,
    setMember,
    tagg,
    setTagg,
    partner,
    setPartner,
    media,
    setMedia,
    responsabile,
    setResponsabile,
    isActive,
    setIsActive,
    handleInputChange,
    handleArray,
    handleChange,
    handleDel,
    handleSubmit,
    handleResetForm,
  };
}
